import { object, ref, string, } from 'yup';
const formSpec = {
    password: string()
        .required('This field is required')
        .matches(new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/), 'Your password must be at least 8 characters long and include at least one uppercase letter, one lowercase letter, and one number.'),
    confirmPassword: string()
        .required('Please retype your password')
        .oneOf([ref('password')], 'Passwords must match'),
};
export const resetPasswordFormSchema = object(formSpec);
